import { Subject } from "rxjs";

export const TASK_MODULE = "task";
export const TASK_ATTACHMENT_MODULE = "task_attachment";
export const TASK_COMMENT_MODULE = "comment";
export const TASK_CLIENT_FEEDBACK_MODULE = "feedback";
export const SUBTASK_MODULE = "subtask";
export const SUBTASK_ATTACHMENT_MODULE = "subtask_attachment";

type SupportedLiveUpdateModule =
  | typeof TASK_MODULE
  | typeof TASK_ATTACHMENT_MODULE
  | typeof TASK_COMMENT_MODULE
  | typeof TASK_CLIENT_FEEDBACK_MODULE
  | typeof SUBTASK_MODULE
  | typeof SUBTASK_ATTACHMENT_MODULE;

export interface LiveUpdateEvent<
  TAction extends string = string,
  TData extends object = object,
  TModule extends string = SupportedLiveUpdateModule | string
> {
  action: TAction;
  action_by: string;
  data: TData;
  module: TModule;
}

export const isLiveUpdateEvent = (event: unknown): event is LiveUpdateEvent =>
  !!(
    event &&
    typeof event === "object" &&
    "action" in event &&
    "data" in event &&
    "module" in event
  );

/**
 * Global event stream for live task-related updates.
 * Can be consumed by both web and mobile apps to react to real-time changes.
 */
export const liveUpdateEvents$ = new Subject<LiveUpdateEvent>();

/**
 * Emits a synthetic live update event.
 *
 * Intended for edge cases where the backend does not emit a real-time event,
 * but the UI still needs to stay in sync. Should be used sparingly and with caution.
 */
export const emitFakeLiveUpdateEvent = (event: LiveUpdateEvent) => {
  liveUpdateEvents$.next(event);
};
